module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-container"
  }, [_c('div', {
    staticClass: "left"
  }), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "call-us"
  }, [_c('p', {
    staticClass: "call"
  }, [_vm._v("Call Us Today! "), _c('span', {
    staticClass: "phone"
  }, [_vm._v(_vm._s(_vm.$store.state.phone))])]), _c('p', {
    staticClass: "est"
  }, [_vm._v("8:30AM to 8:00PM EST.")]), _c('p', {
    staticClass: "pst"
  }, [_vm._v("5:30AM to 5:00PM PST.")]), _c('p', [_vm._v("Copyright 2017 | NavLegal Notaries Inc.")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33d722cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 159
// module chunks = 9